import React from 'react';
import { Church, Star } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ReligionEntryScreenProps {
  onContinue: () => void;
}

const ReligionEntryScreen: React.FC<ReligionEntryScreenProps> = ({ onContinue }) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 via-orange-50 to-rose-50 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 flex flex-col items-center justify-center p-6">
      {/* Header Icon */}
      <div className="relative mb-8">
        <div className="w-24 h-24 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center shadow-lg">
          <Church className="w-12 h-12 text-white" />
        </div>
        <div className="absolute -top-2 -right-2">
          <Star className="w-8 h-8 text-yellow-400 fill-yellow-400" />
        </div>
      </div>

      {/* Title */}
      <h1 className="text-3xl font-bold text-foreground mb-2">Religion</h1>
      <p className="text-lg text-muted-foreground mb-8">Meet people who share your faith</p>

      {/* Description Card */}
      <div className="bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm rounded-2xl p-6 max-w-sm w-full shadow-lg border border-amber-200/50 dark:border-slate-700 mb-8">
        <p className="text-center text-muted-foreground leading-relaxed">
          This space is designed for respectful, faith-aligned connections.
        </p>
      </div>

      {/* Decorative elements */}
      <div className="flex gap-4 mb-8">
        <span className="text-3xl">✡️</span>
        <span className="text-3xl">✝️</span>
        <span className="text-3xl">☪️</span>
        <span className="text-3xl">🕉️</span>
      </div>

      {/* CTA Button */}
      <Button 
        onClick={onContinue}
        className="w-full max-w-sm h-14 text-lg font-semibold bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all"
      >
        Choose Your Faith
      </Button>

      {/* Disclaimer */}
      <p className="text-xs text-muted-foreground mt-6 text-center max-w-xs">
        This space is for respectful, faith-aligned connections only.
      </p>
    </div>
  );
};

export default ReligionEntryScreen;
